import type { ComponentPropsWithoutRef } from 'react'

const FeatureBox = ({ className = '', ...props }: ComponentPropsWithoutRef<'div'>) => <div className={`mb-5 ${className}`} {...props} />

export default FeatureBox
